import { PropsWithChildren, ReactNode } from 'react';

import { Typography, Box, Stack } from '@cast/design-system';
import type { StackProps } from '@cast/design-system';

type Props = {
  prefix?: ReactNode;
  heading: ReactNode;
  postfix?: ReactNode;
  tourSlot?: ReactNode;
} & Omit<StackProps, 'prefix'>;

export type PageHeaderProps = PropsWithChildren<Props>;

/**
 * @deprecated use `PageHeader` from `@cast/design-system`
 */
export const PageHeader = ({
  children,
  prefix,
  heading,
  postfix,
  tourSlot,
  ...boxProps
}: PageHeaderProps) => {
  return (
    <Stack
      direction="row"
      flexWrap="nowrap"
      alignItems="center"
      pb={24}
      gap={8}
      flexGrow={0}
      component="header"
      {...boxProps}
      data-testid="page-header"
    >
      <Stack direction="row" gap={4} flexGrow={1} minWidth={0}>
        {prefix}
        {/* We need to locate the page title for analytics. Added display="contents" to not accidentally break existing pages */}
        <Box id="page-title" display="contents">
          {typeof heading === 'string' ? (
            <Typography
              variant="h3"
              color="textPrimary"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {heading}
              {tourSlot}
            </Typography>
          ) : (
            heading
          )}
        </Box>
        {postfix}
      </Stack>
      {children}
    </Stack>
  );
};
